// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Area from "./layouts/area/index.js";
import CreateRoute from "./layouts/create-route/index.js";
import PermissionManagement from "layouts/permission-management";
import Welcome from "layouts/welcome";
// import Tables from "layouts/tables";
// import Billing from "layouts/billing";
// import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
// import Profile from "layouts/profile";
// import SignIn from "layouts/authentication/sign-in";i
// import SignUp from "layouts/authentication/sign-up";
import CreateStaff from "layouts/create-staff";
import LocationAssignments from "./layouts/location-assignments/index.js";
import AddCompany from "layouts/add-company";
import AddCounter from "layouts/add-counter";
import AddSales from "layouts/add-sales";
import PurchaseRequisition from "layouts/purchase-requisition";
import BelowTargetApprovals from "layouts/below-target-approvals";
import OverdueRequests from "layouts/overdue-requests";
import StaffOverdueResponses from "layouts/overdue-requests/StaffResponses";
import SuspenseRequests from "layouts/suspense-requests";
import OtherDayRequests from "layouts/other-day-requests";
import CancellationRequests from "layouts/cancellation-requests";
import BackdatedPaymentRequests from "layouts/backdated-payment-requests";
import Purchase from "layouts/purchase";
import CreateBawarcheeStaff from "layouts/create-bawarchee-staff";
import UpdatePayment from "layouts/update-payment";
import InvoiceLookup from "layouts/invoice-lookup";
import Credits from "layouts/credits";
import OutBill from "layouts/out-bill";
import BankDeposit from "layouts/bank-deposit";
import Packaging from "layouts/packaging";
import Delivery from "layouts/delivery";
import DeliveryReport from "layouts/delivery-report";
import AssignTask from "layouts/assign-task";
import Delivered from "layouts/delivered";
import DBCollection from "layouts/db-collection";
import ChalanAddSales from "layouts/chalan/add-sales";
import ChalanPackagingDelivery from "layouts/chalan/packaging-delivery";
import ChalanDelivery from "layouts/chalan/delivery";
import ChalanDelivered from "layouts/chalan/delivered";
import ChalanReturn from "layouts/chalan/return";
// import Reports from "layouts/reports";
import DmsStock from "layouts/dms-stock";
import DmsPurchaseHistory from "layouts/dms-purchase-history";
import ExpiryItems from "layouts/expiry-items";
import ExpiryList from "layouts/expiry-list";
import AddSeller from "layouts/add-seller";
import AddItem from "layouts/add-item";
import CurrentStock from "layouts/current-stock";
import PhysicalStock from "layouts/physical-stock";
// import ExpiredStock from "layouts/expired-stock";
// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    requiredPermission: "dashboard",
  },
  {
    type: "collapse",
    name: "Permissions",
    key: "permission-management",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/permission-management",
    component: <PermissionManagement />,
    allowedRoles: ["admin"],
  },
  {
    type: "collapse",
    name: "Welcome",
    key: "welcome",
    icon: <Icon fontSize="small">waving_hand</Icon>,
    route: "/welcome",
    component: <Welcome />,
    allowedRoles: ["packaging_staff", "bawarchee_staff", "delivery_boy"],
    hideWhenPermissionsAssigned: true,
  },
  // {
  //   type: "collapse",
  //   name: "Reports",
  //   key: "reports",
  //   icon: <Icon fontSize="small">summarize</Icon>,
  //   route: "/reports",
  //   component: <Reports />,
  // },
  {
    type: "collapse",
    name: "DMS",
    key: "dms",
    icon: <Icon fontSize="small">inventory</Icon>,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    requiredPermission: "dms",
    collapse: [
      {
        type: "collapse",
        name: "Add Seller",
        key: "add-seller",
        icon: <Icon fontSize="small">storefront</Icon>,
        route: "/add-seller",
        component: <AddSeller />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "add_seller",
      },
      {
        type: "collapse",
        name: "Add Item",
        key: "add-item",
        icon: <Icon fontSize="small">category</Icon>,
        route: "/add-item",
        component: <AddItem />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "add_item",
      },
      {
        type: "collapse",
        name: "Item List",
        key: "dms-stock",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        route: "/dms-stock",
        component: <DmsStock />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "item_list",
      },

      {
        type: "collapse",
        name: "Purchase History",
        key: "dms-purchase-history",
        icon: <Icon fontSize="small">history</Icon>,
        route: "/dms-purchase-history",
        component: <DmsPurchaseHistory />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "purchase_history",
      },

    

      {
        type: "collapse",
        name: "Physical Stock",
        key: "physical-stock",
        icon: <Icon fontSize="small">warehouse</Icon>,
        route: "/physical-stock",
        component: <PhysicalStock />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "physical_stock",
      },
      {
        type: "collapse",
        name: "Current Stock",
        key: "current-stock",
        icon: <Icon fontSize="small">fact_check</Icon>,
        route: "/current-stock",
        component: <CurrentStock />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "current_stock",
      },
      {
        type: "collapse",
        name: "Expiry Items",
        key: "expiry-items",
        icon: <Icon fontSize="small">event_busy</Icon>,
        route: "/expiry-items",
        component: <ExpiryItems />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "expiry_items",
      },
      {
        type: "collapse",
        name: "Expiry List",
        key: "expiry-list",
        icon: <Icon fontSize="small">event_note</Icon>,
        route: "/expiry-list",
        component: <ExpiryList />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "expiry_list",
      },
      {
        type: "collapse",
        name: "Damage List",
        key: "damage-list",
        icon: <Icon fontSize="small">broken_image</Icon>,
        route: "/damage-list",
        component: <ExpiryList mode="damage" />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "damage_list",
      },
      {
        type: "collapse",
        name: "Purchase",
        key: "purchase",
        icon: <Icon fontSize="small">receipt_long</Icon>,
        route: "/purchase",
        component: <Purchase />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "purchase",
      },

      // {
      //   type: "collapse",
      //   name: "Expired Stock",
      //   key: "expired-stock",
      //   icon: <Icon fontSize="small">swap_horiz</Icon>,
      //   route: "/expired-stock",
      //   component: <ExpiredStock />,
      // },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  {
    type: "collapse",
    name: "Staff Management",
    key: "staff-management",
    icon: <Icon fontSize="small">people</Icon>,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy", "staff"],
    collapse: [
      {
        type: "collapse",
        name: "Create Area",
        key: "area",
        icon: <Icon fontSize="small">place</Icon>,
        route: "/area",
        component: <Area />,
        allowedRoles: ["admin"],
      },
      {
        type: "collapse",
        name: "Create Route",
        key: "create-route",
        icon: <Icon fontSize="small">alt_route</Icon>,
        route: "/create-route",
        component: <CreateRoute />,
        allowedRoles: ["admin"],
      },
      {
        type: "collapse",
        name: "Add Company",
        key: "add-company",
        icon: <Icon fontSize="small">domain</Icon>,
        route: "/add-company",
        component: <AddCompany />,
      },
      {
        type: "collapse",
        name: "Create Staff",
        key: "create-staff",
        icon: <Icon fontSize="small">person_add</Icon>,
        route: "/create-staff",
        component: <CreateStaff />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "create_staff",
      },
      {
        type: "collapse",
        name: "Add Location",
        key: "location-assignments",
        icon: <Icon fontSize="small">location_on</Icon>,
        route: "/location-assignments",
        component: <LocationAssignments />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy", "staff"],
        requiredPermission: "location_assignments",
      },
      {
        type: "collapse",
        name: "Bawarchee Staff",
        key: "create-bawarchee-staff",
        icon: <Icon fontSize="small">local_shipping</Icon>,
        route: "/create-bawarchee-staff",
        component: <CreateBawarcheeStaff />,
      },

    ],
  },
  {
    type: "collapse",
    name: "Add Outlet",
    key: "add-outlet",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/add-outlet",
    component: <AddCounter />,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy", "staff"],
    requiredPermission: "add_outlet",
  },
  {
    type: "collapse",
    name: "Purchase Requisition",
    key: "purchase-requisition",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/purchase-requisition",
    component: <PurchaseRequisition />,
    allowedRoles: ["staff"],
  },
  {
    type: "collapse",
    name: "Overdue Requests",
    key: "overdue-responses",
    icon: <Icon fontSize="small">assignment_late</Icon>,
    route: "/overdue-responses",
    component: <StaffOverdueResponses />,
    allowedRoles: ["staff"],
  },
  {
    type: "collapse",
    name: "Approvals",
    key: "approvals",
    icon: <Icon fontSize="small">verified</Icon>,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    collapse: [
      {
        type: "collapse",
        name: "Requisition Approvals",
        key: "requisition-approvals",
        icon: <Icon fontSize="small">approval</Icon>,
        route: "/requisition-approvals",
        component: <PurchaseRequisition />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "requisition_approval",
      },
      {
        type: "collapse",
        name: "Below Target Approvals",
        key: "below-target-approvals",
        icon: <Icon fontSize="small">trending_down</Icon>,
        route: "/below-target-approvals",
        component: <BelowTargetApprovals />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "requisition_target_approval",
      },
      {
        type: "collapse",
        name: "Overdue Requests",
        key: "overdue-requests",
        icon: <Icon fontSize="small">assignment_late</Icon>,
        route: "/overdue-requests",
        component: <OverdueRequests />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "overdue_approval",
      },
      {
        type: "collapse",
        name: "Suspense Requests",
        key: "suspense-requests",
        icon: <Icon fontSize="small">pause_circle</Icon>,
        route: "/suspense-requests",
        component: <SuspenseRequests />,
        allowedRoles: ["admin"],
      },
      {
        type: "collapse",
        name: "Cancellation Approvals",
        key: "cancellation-requests",
        icon: <Icon fontSize="small">cancel_schedule_send</Icon>,
        route: "/cancellation-requests",
        component: <CancellationRequests />,
        allowedRoles: ["admin"],
      },
      {
        type: "collapse",
        name: "Backdated Payment Approvals",
        key: "backdated-payment-requests",
        icon: <Icon fontSize="small">history</Icon>,
        route: "/backdated-payment-requests",
        component: <BackdatedPaymentRequests />,
        allowedRoles: ["admin"],
      },
      {
        type: "collapse",
        name: "Other Day Bit Requests",
        key: "other-day-requests",
        icon: <Icon fontSize="small">event_busy</Icon>,
        route: "/other-day-requests",
        component: <OtherDayRequests />,
        allowedRoles: ["admin"],
      },
    ],
  },
  {
    type: "collapse",
    name: "Add Sales",
    key: "add-sales",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/add-sales",
    component: <AddSales />,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    requiredPermission: "add_sales",
  },
  {
    type: "collapse",
    name: "Assign Task",
    key: "assign-task",
    icon: <Icon fontSize="small">assignment_ind</Icon>,
    route: "/assign-task",
    component: <AssignTask />,
    allowedRoles: ["packaging_staff", "delivery_boy", "staff"],
  },
  {
    type: "collapse",
    name: "Delivery Manager",
    key: "delivery-management",
    icon: <Icon fontSize="small">local_shipping</Icon>,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    collapse: [
      {
        type: "collapse",
        name: "Packaging",
        key: "packaging",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        route: "/packaging",
        component: <Packaging />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "packaging",
      },
      {
        type: "collapse",
        name: "Delivery",
        key: "delivery",
        icon: <Icon fontSize="small">local_shipping</Icon>,
        route: "/delivery",
        component: <Delivery />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "delivery",
      },
      {
        type: "collapse",
        name: "Report",
        key: "delivery-report",
        icon: <Icon fontSize="small">summarize</Icon>,
        route: "/delivery-report",
        component: <DeliveryReport />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "delivery_report",
      },
      {
        type: "collapse",
        name: "Delivered",
        key: "delivered",
        icon: <Icon fontSize="small">verified</Icon>,
        route: "/delivered",
        component: <Delivered />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "delivered",
      },
    ],
  },
  {
    type: "collapse",
    name: "Chalan",
    key: "chalan",
    icon: <Icon fontSize="small">description</Icon>,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    collapse: [
      {
        type: "collapse",
        name: "Add Sales",
        key: "chalan-add-sales",
        icon: <Icon fontSize="small">payments</Icon>,
        route: "/chalan-add-sales",
        component: <ChalanAddSales />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "chalan_add_sales",
      },
      {
        type: "collapse",
        name: "Packaging Delivery",
        key: "chalan-packaging-delivery",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        route: "/chalan-packaging-delivery",
        component: <ChalanPackagingDelivery />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "chalan_packaging",
      },
      {
        type: "collapse",
        name: "Delivery",
        key: "chalan-delivery",
        icon: <Icon fontSize="small">local_shipping</Icon>,
        route: "/chalan-delivery",
        component: <ChalanDelivery />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "chalan_delivery",
      },
      {
        type: "collapse",
        name: "Delivered",
        key: "chalan-delivered",
        icon: <Icon fontSize="small">verified</Icon>,
        route: "/chalan-delivered",
        component: <ChalanDelivered />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "chalan_delivered",
      },
      {
        type: "collapse",
        name: "Return",
        key: "chalan-return",
        icon: <Icon fontSize="small">keyboard_return</Icon>,
        route: "/chalan-return",
        component: <ChalanReturn />,
        allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
        requiredPermission: "chalan_return",
      },
    ],
  },
  {
    type: "collapse",
    name: "Invoice Lookup",
    key: "invoice-lookup",
    icon: <Icon fontSize="small">manage_search</Icon>,
    route: "/invoice-lookup",
    component: <InvoiceLookup />,
    // Marketing staff see only their own invoices (enforced by the API).
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy", "staff"],
    requiredPermission: "invoice_lookup",
  },
  {
    type: "collapse",
    name: "Update Payment",
    key: "update-payment",
    icon: <Icon fontSize="small">edit_note</Icon>,
    route: "/update-payment",
    component: <UpdatePayment />,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    requiredPermission: "update_payment",
  },
  {
    type: "collapse",
    name: "D.B. Collection",
    key: "db-collection",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/db-collection",
    component: <DBCollection />,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    requiredPermission: "db_collection",
  },

  {
    type: "collapse",
    name: "Give Credit",
    key: "credits",
    icon: <Icon fontSize="small">price_change</Icon>,
    route: "/credits",
    component: <Credits />,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    requiredPermission: "credits",
  },
  {
    type: "collapse",
    name: "Out Bill",
    key: "out-bill",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/out-bill",
    component: <OutBill />,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    requiredPermission: "out_bill",
  },
  {
    type: "collapse",
    name: "Bank Deposit",
    key: "bank-deposit",
    icon: <Icon fontSize="small">account_balance</Icon>,
    route: "/bank-deposit",
    component: <BankDeposit />,
    allowedRoles: ["admin", "packaging_staff", "bawarchee_staff", "delivery_boy"],
    requiredPermission: "bank_deposit",
  },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/authentication/sign-in",
  //   component: <SignIn />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default routes;
